<template>
  <div
    class="sl-card"
    :class="{transparent}"
  >
    <div
      class="card-body"
      :class="customClass"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseCard',
  props: {
    none: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: Boolean,
      default: false,
    },
    condensed: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    customClass() {
      return [
        this.none ? 'sl-card--none' : '',
        this.custom ? 'sl-card--custom' : '',
        this.condensed ? 'sl-card--condensed' : '',
        this.small ? 'sl-card--small' : '',
        this.medium ? 'sl-card--medium' : '',
        this.large ? 'sl-card--large' : '',
        this.expanded ? 'sl-card--expanded' : '',

      ];
    },
  },
};
</script>
<style lang="scss">
.sl-card {
  &:not(.transparent) {
    background: white;
  }
  border-radius: 5px;
  &--none {
    padding: 0rem !important;
  }
  &--custom {
    padding: 15px 4px 0px 4px !important;
  }
  &--condensed {
    padding: 0.625rem !important;
  }
  &--small {
    padding: 16px;
  }
  &--medium {
    padding: toRem(28);
    // padding: 1.97rem !important;
  }
  &--large {
    padding: toRem(18) toRem(32);
  }
  &--expanded {
    padding: 40px !important;
    // padding: 3.125rem !important;
  }
  @media (max-width: map-get($breakpoints,'lg')) {
    &--large {
      padding: toRem(10) toRem(16);
    }
  }
}
</style>
